<template>
  <auth-layout title="Account Owner" :stepNo="stepNo" :totalSteps="totalSteps">
    <div class="shadow rounded w-full md:w-4/5 mx-auto text-darkBlue mt-8 mb-8">
      <div class="banner">
        <div class="pt-16 pl-6">
          <img
            src="@/assets/images/profile-img.png"
            alt="profile picture"
            class="w-32 h-32 img-fluid"
          />
        </div>
      </div>
      <div class="px-10 py-12">
        <form @submit.prevent class="">
    
          <div class="">
            <label class="label">First Name <span class="text-red-500">*</span></label>
            <base-input v-model="accountOwner.firstname" />
          </div>
          <div>
            <label class="label">Last Name <span class="text-red-500">*</span></label>
            <base-input v-model="accountOwner.lastname" />
          </div>

          <div>
            <label class="label">Gender <span class="text-red-500">*</span></label>
            <el-select v-model="accountOwner.gender" placeholder="">
              <el-option
                v-for="gender in genders"
                :key="gender"
                :label="gender"
                :value="gender"
              >
              </el-option>
            </el-select>
          </div>
          <div class="mt-3">
            <label class="label">Email Address <span class="text-red-500">*</span></label>
            <base-input v-model="accountOwner.email" />
          </div>
          <div>
            <label class="label">Mobile Number (Preferably a WhatsApp number) <span class="text-red-500">*</span></label>
            <vue-tel-input :preferredCountries="['Nigeria', 'Ghana']" v-model="accountOwner.mobile_no"></vue-tel-input>
          </div>
          <div class="my-2">
            <base-checkbox v-model="sendUpdate"
              label="Send me status updates regarding my shipment with the email provided."
            />
          </div>
          <div class="flex justify-end">
            <!-- <base-button
              text="Back"
              background="#DAE8F6"
              p="py-2 px-8"
              @click="goToPreviousPage"
            /> -->
            <base-button
              text="Continue"
              p="py-2 px-8"
              :disabled="disableNextButton"
              :loading="savingAccountOwnerInfo"
              @click="saveAccountOwnerInformation"
            />
          </div>
        </form>
      </div>
    </div>

    <template v-slot:text>
      <div class="text-white">
        <h1 class="text-3xl font-bold">
          Account Owner
        </h1>
      </div>
    </template>
  </auth-layout>
</template>

<script>
import AuthLayout from "../../Auth/Authlayout/OnDemand";
export default {
  components: {
    AuthLayout,
  },
  data() {
    return {
      sendUpdate : false,
      accountOwner: {
        firstname: "",
        lastname: "",
        gender: "",
        mobile_no: "",
        email: "",
        imageurl: "",
      },
      genders: ["Male", "Female"],
      loading: false,
      savingAccountOwnerInfo: false,
      totalSteps: "3",
      stepNo: "3",
      accountType: null,
      isUploadingImage: false,
    };
  },
  computed: {
    disableNextButton() {
      let { firstname, lastname, gender, mobile_no, email } = this.accountOwner;
      if (
        firstname.length &&
        lastname.length &&
        gender.length &&
        mobile_no.length &&
        this.validateEmail(email)
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  mounted() {
    this.accountType = localStorage.getItem("account-type");
    this.getUserDetails();
    if (!this.accountType) {
      this.$router.push("/onboarding");
    } else if (this.accountType == "individual") {
      this.totalSteps = "3";
      this.stepNo = "3";
    } else {
      this.totalSteps = "4";
      this.stepNo = "3";
    }
  },
  methods: {
    async saveAccountOwnerInformation() {
      this.savingAccountOwnerInfo = true;
      let userId = localStorage.getItem("userId");
      this.accountOwner.userId = userId;
      try {
        let response = await this.$_saveOnboardingAccountOwnerInformation(
          this.accountOwner, userId
        );
        console.log(response);
        this.onSuccessfulRequest(response);
      } catch (error) {
        console.log(error);
        this.handleError(error);
        this.savingAccountOwnerInfo = false;
      }
    },
    onSuccessfulRequest() {
      this.savingAccountOwnerInfo = false;
      if (this.accountType == "individual") {
        this.$router.push("/onboarding/complete");
      } else {
        this.$router.push("/onboarding/organization-information");
      }
    },
    async uploadImage(image) {
      this.isUploadingImage = true;
      const formData = new FormData();
      formData.append("file", image);
      formData.append("upload_preset", "zunt8yrw");
      try {
        let response = await this.$_uploadImage(formData);
        this.accountOwner.imageurl = response.data.secure_url;
        this.isUploadingImage = false;
        this.generateToast("Image uploaded", "success");
      } catch (error) {
        this.handleError(error);
        this.isUploadingImage = false;
      }
    },
    removeImage() {
      this.accountOwner.imageurl = null;
    },
    goToPreviousPage() {
      this.$router.push("/onboarding/account-type");
    },
    getUserDetails() {
      let userDetails = JSON.parse(localStorage.getItem("account-owner"));
      if (!userDetails) {
        this.$router.push("/signup");
      } else {
        this.accountOwner.firstname = userDetails.firstname;
        this.accountOwner.lastname = userDetails.lastname;
        this.accountOwner.mobile_no = userDetails.mobile_no;
        this.accountOwner.email = userDetails.email;
      }
    },
  },
};
</script>

<style scoped>
.banner {
  width: 100%;
  height: 9rem;
  background-color: rgb(6, 6, 71);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
</style>